<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="신용조회" :type="'agent'" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>동의</span></li>
            <li class="on"><span>본인인증</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">
              <strong>고객님</strong>
              , 반갑습니다.
            </h2>
            <p class="desc">안전한 진행을 위한 본인인증을 진행합니다.</p>
          </div>

          <div class="formArea">
            <span class="label">이름</span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="contInfo.customerName" autocomplete="off" />

            <span class="label">생년월일</span>
            <div class="setBirth type2">
              <input
                type="tel"
                class="ipt"
                maxlength="6"
                title="주민등록 앞 6자리 입력"
                id="ssn"
                placeholder=""
                v-model="contInfo.ssn"
                v-onlyNum
                v-skipOfMax
                nextTarget="backSsn"
                autocomplete="off"
              />
              <span class="sign" aria-hidden="true">-</span>
              <input
                type="tel"
                class="ipt"
                maxlength="1"
                title="주민등록 뒤 1자리 입력"
                id="backSsn"
                placeholder=""
                v-model="backSsn"
                v-onlyNum
                autocomplete="off"
              />
              <span class="sign" aria-hidden="true">******</span>
            </div>

            <span class="label">휴대폰번호</span>

            <div :class="'setAgency ' + [rvalue ? '' : 'selected']">
              <!-- 알뜰폰 선택 시 클래스추가 : selected -->
              <ul class="iptGroup iptBtn">
                <li>
                  <input
                    type="radio"
                    class="ipt"
                    name="rdosort"
                    id="agency_1"
                    checked="checked"
                    v-model="rvalue"
                    v-bind:value="1"
                    v-on:click="changeRdoData($event)"
                  />
                  <label for="agency_1">SKT</label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="agency_2" v-model="rvalue" v-bind:value="2" v-on:click="changeRdoData($event)" />
                  <label for="agency_2">KT</label>
                </li>
                <li>
                  <input type="radio" class="ipt" name="rdosort" id="agency_3" v-model="rvalue" v-bind:value="3" v-on:click="changeRdoData($event)" />
                  <label for="agency_3">LGU+</label>
                </li>
              </ul>
              <select class="ipt" id="agency_4" title="통신사 선택" v-model="svalue" v-on:change="changeSltData($event)">
                <option value="">알뜰폰</option>
                <option value="5">SK알뜰폰</option>
                <option value="6">KT알뜰폰</option>
                <option value="7">LGU+알뜰폰</option>
              </select>
            </div>

            <div class="setAddr uiAct">
              <div class="iptWrap">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="contInfo.cellNum"
                  v-onlyNum
                />
              </div>

              <button type="button" class="btn_g m" @click="sendAuthNumber" v-if="!timeCheck">{{ authButtonTitle }}</button>
              <button type="button" class="btn_g m" style="opacity: 0.6" v-else>인증완료</button>
            </div>
            <div class="setAddr uiAct" v-show="authTime > 0 && !timeCheck">
              <input
                type="tel"
                id="phone_3"
                class="ipt addTxt"
                title="인증번호 입력"
                v-model="authNum"
                v-onlyNum
                autocomplete="off"
                placeholder="인증번호 입력"
              />
              <span class="txt">
                <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
              </span>

              <button type="button" class="btn_g m" @click="checkNumber">인증번호확인</button>
            </div>
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="nextStep" :disabled="!buttonCheck">완료</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import { isEmpty, checkBackPeop } from '@/common/common.function';
import MessagePop from '@/components/popup/MessagePop';
import { AUTH_TIMEOUT } from '@/store/message.type.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
export default {
  name: 'guestStep2',
  components: {
    MessagePop,
    ConfirmPop,
  },
  mounted() {
    this.request = this.$route.params.request;
    ApiService.service('GET', `/order/selectPreorderMaster/${this.request.orderCommInfo.orderId}`)
    .then(({ data }) => {
      this.checkPreOrderId = true;
      this.preOrderCellnum = data.result.cellNum.replace(/[^0-9]/g, '');
    })
    .catch(({ response }) => {
      this.msg = SERVICE_COMM_ERROR;
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return;
    });
  },
  data() {
    return {
      checkPreOrderId: false,
      preOrderCellnum: '',
      insAddr: false,
      msg: '',
      messagePop: false,
      confirmPop: false,
      findAddr: false,

      //본인인증관련
      tr_id: '',
      authKey: null, //인증번호
      uniqueKey: null,
      count: null, //제한시간
      time: '3:00', //인증시간text
      authButtonTitle: '인증번호요청', // 인증번호 버튼명 ( 인증번호요청 / 재요청 )
      authTime: 0, // 초기 세팅 시간 테스트로 10초로 설정 원래는 180초
      authNum: null,
      countDown: {},
      timeCheck: false, //본인인증여부
      backSsn: '', //주민번호 뒷자리
      buttonCheck: false, //버튼활성화여부
      yy: '',

      //유저정보
      localCode: ['Y', 'N'],
      sexCode: ['RCSB000M', 'RCSB00WM'],
      cellCode: ['MBCP0001', 'MBCP0002', 'MBCP0003', 'MBCP0005', 'MBCP0006', 'MBCP0007'],

      rvalue: 1,
      svalue: '',

      contInfo: {
        customerName: null,
        localUserYn: 'Y',
        ssn: null,
        sex: '1',
        userIdentityComp: '1',
        cellNum: null,
      },
      addrType: 'N',
      conOrderInfo: {
        // 거주지 정보
        cellNum: '',
        conAddrCode: '',
        conAddrJibun: '',
        conAddrPost: '',
        conAddrRemark: '',
        conAddrRoad: '',
        oriNadr1: '',
        oriNadr3: '',
        oriBld: '',
        customerName: '',
        localUserYn: '', // 내국인 여부. Y: 내국인
        sex: '',
        ssn: '',
        userIdentityComp: '', // 통신사 코드
      },
      installInfo: {
        // 설치지 정보
        installAddrCode: '',
        installAddrJibun: '',
        installAddrPost: '',
        installAddrRemark: '',
        installAddrRoad: '',
        oriNadr1: '',
        oriNadr3: '',
        oriBld: '',
        installCellNum: '', // 배송연락처 휴대폰번호
        installReqDate: '', // 설치/배송 예상일 (형식: YYYYMMDD)
        installUserName: '', // 배송연락처 이름
      },
      request: null,
      goFindID: false,
      rclipsComplete: false,
    };
  },
  watch: {
    conOrderInfo() {
      console.log(this.conOrderInfo.conAddrRemark);
    },
    backSsn() {
      let data = checkBackPeop(this.backSsn);
      this.contInfo.sex = data._sex;
      this.contInfo.localUserYn = data._local;
      this.conOrderInfo.localUserYn = data._local;
      this.yy = data._yyyy;
    },
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        //this.authTime = 10; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
  },

  methods: {
    addrPopupOpen(type) {
      this.addrType = type;
      this.findAddr = true;
    },
    nextStep() {
      this.checkPeople();
    },
    validate() {
      if (isEmpty(this.contInfo.customerName)) {
        this.msg = '이름을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      if (isEmpty(this.contInfo.ssn)) {
        this.msg = '생년월일을 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      if (isEmpty(this.contInfo.cellNum)) {
        this.msg = '휴대폰번호를 입력해주세요.';
        setTimeout(() => {
          this.messagePop = true;
        }, 100);
        return false;
      }
      return true;
    },

    changeRdoData(evt) {
      console.log(evt.target.value);
      this.svalue = '';
      this.rvalue = evt.target.value;
      this.contInfo.userIdentityComp = evt.target.value;
      this.request.conOrderInfo.userIdentityComp = 'MBCP000' + evt.target.value;
    },
    changeSltData(evt) {
      console.log(evt.target.value);
      this.rvalue = '';
      this.svalue = evt.target.value;
      this.contInfo.userIdentityComp = evt.target.value;
      this.request.conOrderInfo.userIdentityComp = 'MBCP000' + evt.target.value;
    },
    //인증번호 요청
    sendAuthNumber() {
      if (!this.validate()) {
        return;
      }
      // 주문번호가 없는 경우
      if (!this.request.orderCommInfo.orderId) {
        this.msg = '주문번호가 조회되지 않습니다. 전산팀에 문의하세요. ';
          setTimeout(() => {
            this.messagePop = true;
          }, 100);
        return;
      }
      if (this.contInfo.cellNum != this.preOrderCellnum){
        this.msg = "본심사를 진행해야 결과가 확인됩니다.";
        this.messagePop = true;
        return;
      }      
      // 입력한 정보를 바탕으로 유저 정보 update
      // [이름, 전화번호, 생년월일, 성별, 주문번호]
      let vue = this;
      vue.conOrderInfo.customerName = vue.contInfo.customerName;
      vue.conOrderInfo.cellNum = vue.contInfo.cellNum;
      vue.conOrderInfo.ssn = this.yy + vue.contInfo.ssn;
      vue.conOrderInfo.backSsn = vue.backSsn;
      vue.conOrderInfo.userIdentityComp = this.request.conOrderInfo.userIdentityComp;
      vue.request.conOrderInfo = vue.conOrderInfo;
      if (vue.conOrderInfo.backSsn === '1' || vue.conOrderInfo.backSsn === '3') {
        vue.conOrderInfo.backSsn = 'RCSB000M';
      } else {
        vue.conOrderInfo.backSsn = 'RCSB00WM';
      }
      // update Api
      ApiService.service('POST', 'order/updatePreAcptMaster', {
        conBirth: vue.conOrderInfo.ssn,
        conOrdrNm: vue.conOrderInfo.customerName,
        conCellNum: vue.conOrderInfo.cellNum,
        sexCd: vue.conOrderInfo.backSsn,
        orderId: this.request.orderCommInfo.orderId,
      })
        .then((response) => {
          if (response.data.isSucceed && response.data.result.resultCode != 1) {
            ApiService.service('POST', 'external/verification', {
              request: {
                cellNum: this.contInfo.cellNum,
                customerName: this.contInfo.customerName,
                //orderId: this.request.orderCommInfo.orderId,
                sex: this.contInfo.sex,
                localUserYn: this.contInfo.localUserYn,
                ssn: this.yy + this.contInfo.ssn,
                userIdentityComp: this.contInfo.userIdentityComp,
              },
              serviceType: 'app',
            })
              .then((response) => {
                if (!response.data.isSucceed) {
                  this.msg = response.data.error;
                  this.messagePop = true;
                }
                this.timeCheck = false;
                this.uniqueKey = response.data.result.uniqueKey;
                //시간
                this.authButtonTitle = '재요청'; // 인증 진행시 버튼 TITLE 변경
                this.authTime = 180;
                clearInterval(this.countDown); // 재 요청시 시간 초기화 필요
                this.countDown = setInterval(() => {
                  this.authTime--;
                }, 1000);
              })
              .catch((response) => {
                console.log(response);
              });
          } else {
            console.log(response);
            this.authNum = null;
            this.msg = response.data.error;
            this.messagePop = true;
          }
        })
        .catch((response) => {
          console.log(response);
          this.msg = response.data.error;
          this.messagePop = true;
        });
    },

    checkNumber() {
      if (this.authNum.length != 6) {
        this.msg = `입력받은 인증번호 6자리를 입력해주세요`;
        this.messagePop = true;
      }

      //let vue = this;
      // API 호출
      ApiService.service('PUT', 'external/verification', {
        request: {
          authNum: this.authNum,
          cellNum: this.contInfo.cellNum,
          customerName: this.contInfo.customerName,
          orderId: this.request.orderCommInfo.orderId,
          uniqueKey: this.uniqueKey,
          sex: this.contInfo.sex,
          localUserYn: this.contInfo.localUserYn,
          ssn: this.yy + this.contInfo.ssn,
          userIdentityComp: this.contInfo.userIdentityComp,
        },
        serviceType: 'app',
      })
        .then(async (response) => {
          console.log(response)
          if (!response.data.isSucceed) {
            this.msg = response.data.error; // API에서 response 해주는 message
            this.errorCode = response.data.errorCode; // API에서 response 해주는 errorCode
            this.messagePop = true;
          } else {
            this.buttonCheck = true;
            this.msg = "인증이 완료되었습니다."
            this.messagePop = true;
            document.getElementById('phone_2').disabled = true;
            this.timeCheck = true;
            clearInterval(this.countDown);
            //정보 업데이트
          }
        })
        .catch((response) => {
          console.log(response);
          // this.msg = response.data.error;
          // this.messagePop = true;
        });
    },
    checkPeople() {
      let vue = this;
      vue.request.installInfo = this.installInfo;
      this.request.orderCommInfo.requestKey = this.uniqueKey;
      this.$refs.header.loadingStart(); // 로딩시작
      if (this.rclipsComplete == true) {
        this.confirmPop = true;
        return;
      }
      ApiService.service('POST', 'order/agentCredit', {
        request: {
          orderId: this.request.orderCommInfo.orderId,
          smsUniqueKey: this.uniqueKey,
        },
        serviceType: 'app',
      })
      .then((response) => {
          this.request.orderCommInfo.creditKey = response.data.result.resultData;
          if (response.data.isSucceed) {
            this.rclipsComplete = true;
            this.msg = "완료되었습니다. 홈페이지로 이동하시겠습니까?"
            this.confirmPop = true;
          } else {
            console.log(response.data);
            this.$router.push('/order/rental/rentalReject');
          }
      })
      .catch((response) => {
          console.log(response);
          // this.msg = response.data.error;
          // this.messagePop = true;
      })
      .finally(() => {
        this.$refs.header.loadingEnd(); // 로딩끝
      });
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.findAddr = false;
    },
    cancel() {
      // 취소 선택시 팝업 닫기
      this.confirmPop = false;
    },
    confirm() {
      this.$router.replace('/');
    },
  },
};
</script>